App.module('MessageCenterApp.Views', function(Views, App, Backbone, Marionette, $, _){
    'use strict';

    Views.MessageItem = Marionette.ItemView.extend({
        template: '#message-center-item',
        tagName: 'div',
        className: 'messageCenterModalRow',
        events: {
            'tap @ui.deleteButton': 'onDelete', // ToDo: check for Mobile
            'tap @ui.headline': 'onMessageOpen',
            'tap @ui.messageCenterModalMessageLess': 'onMessageClose',
            'tap a': 'onClickLink'
        },
        ui: {
            headline: '.headline',
            title: 'span.title',
            text: '.fulltext',
            deleteButton: '.deleteButton',
            messageCenterModalMessageLess: '.messageCenterModalMessageLess'
        },
        initialize: function() {
            this.on('messageCenter:messages:successfullyDeleted', _.bind(this.onSuccessfullyDeleted, this));
            this.on('messageCenter:messages:successfullyViewed', _.bind(this.onSuccessfullyViewed, this));
            this.on('messageCenter:messages:delete:canceled', _.bind(this.onDeleteCanceled, this));
            this.on('messageCenter:messages:onBeforeGoByLink', function(evStatus) {
                evStatus.ready = window.VHR_SAVE_CHANGES ? false : true;
            });

            if (this.model.get('seen')) {
                this.$el.addClass('read');
            }

            this.bindUIElements();
        },
        onClickLink: function(e){
            var evStatus = {ready: true},
                $target = $(e.currentTarget);

            this.trigger('messageCenter:messages:onBeforeGoByLink', evStatus);
            if(! $target.data('display-leaving-website-popup') && $target.attr('target') !== '_blank' && evStatus.ready) {
                window.location.href = $(e.currentTarget).attr('href');
            }
        },
        collapse: function() {
            this.ui.title.removeClass('expanded');
            this.ui.text.toggle(false);
            this.opened = false;
        },
        onMessageOpen: function() {
            if (this.opened) {
                this.collapse();
                App.trigger('messageCenter:refreshIScroll');
                return;
            }

            this.opened = true;

            if (! this.model.get('seen')) {
                this.trigger('messageCenter:messages:openNewMessage');
            }
            this.trigger('messageCenter:messages:openMessage');

            this.ui.title.addClass('expanded');
            this.ui.text.toggle();

            App.trigger('messageCenter:refreshIScroll');
        },
        onMessageClose: function() {
            this.collapse();
            App.trigger('messageCenter:refreshIScroll');
        },
        onDelete: function(e) {
            e.preventDefault();

            $('#messageCenterPopupRemove').css('right', 0).css('bottom', 0).modal('show');
            this.trigger('messageCenter:messages:delete', this.model.get('id'));

            // TVGUSA-31619
            this.ui.deleteButton.addClass('active');
        },
        onSuccessfullyDeleted: function() {
            this.model.set('deleted', true);
            this.$el.remove();

            // TVGUSA-31619
            this.ui.deleteButton.removeClass('active');
        },
        onDeleteCanceled: function() {
            // TVGUSA-31619
            this.ui.deleteButton.removeClass('active');
        },
        onSuccessfullyViewed: function() {
            this.model.set('seen', true);
            this.$el.addClass('read');
        },
        onRender: function() {
            bindCmsEdit(this.$el);

            this.bindUIElements();
        }
    });

    Views.MessagesBox = Marionette.CollectionView.extend({
        //countItemLoad: 10,
        tagName: 'div',
        className: '',
        childView: Views.MessageItem,
        ui: {},
        events: {},
        initialize: function () {
            App.on('messageCenter:calcNewMessages', _.bind(this.calcNewMessages, this));
            this.listenTo(this, 'childview:messageCenter:messages:openMessage', this.collapseView);
            this.listenTo(this.collection, 'add', this.addOne);
        },
        collapseView: function(childview) {
            this.children.each(function(view){
                if (childview === view) {
                    return;
                }
                view.collapse();
            });
        },
        calcNewMessages: function() {
            var collection = this.collection,
                countNewMessages = 0;

            _.each(collection.models, function(val) {
                if(!val.get('seen')) {
                    countNewMessages++;
                }
            });
        },
        addOne: function (model) {
            var view = new Views.MessageItem({
                model: model,
                collection : this.collection
            });
            view.render();
        }
    });

    Views.MessageCenter = Marionette.ItemView.extend({
        countNewMessages: 0,
        countAllMessages: 0,
        maxCountMessages: 5,
        messagesInitialized: false,
        viewAll: false,
        el: '#messageCenter',
        template: false,
        ui: {
            iScrollContainer: '#messageCenterModalContent',
            messagesListContainer: '#messagesListContainer',
            viewAllButton: '.viewAllButton',
            viewLessButton: '.viewLessButton',
            messageCenterModalCloseButton: '.messageCenterModalClose',
            messageCenterModalRows: '.messageCenterModalRow',
            emptyMessageCenterMessage: '#emptyMessageCenterMessage',
            msgControlButtonsContainer: '#msgControlButtons'
        },
        events: {
            'tap @ui.viewAllButton': 'viewAllMessages',
            'tap @ui.viewLessButton': 'viewLessMessages',
            'click @ui.messageCenterModalCloseButton': 'closeMessageCenter'
        },
        initialize: function () {
            var self = this;

            App.on('messageCenter:toggleView', _.bind(this.toggleMessageCenterView, this));
            App.on('messageCenter:setCountNewMessages', _.bind(this.setCountNewMessages, this));
            App.on('messageCenter:messages:successfullyDeleted', _.bind(this.onSuccessfullyDeleted, this));
            App.on('messageCenter:refreshIScroll', _.bind(this.iScrollRefresh, this));
            App.on('messageCenter:messages:inited', _.bind(this.onMessageCenterInited, this));
            App.on('messageCenter:messages:cannotLoad', _.bind(this.showEmptyView, this));
            App.commands.setHandler('views:messageCenter:open', _.bind(this.openMessageCenter, this));

            this.bindUIElements();

            this.showEmptyView();

            //TVGUSA-28102
            this.on('messageCenter:recalculateCountMessages', _.bind(this.recalculateCountMessages, this));

            $('.messageCenterButton, .menu-mail-item').on('click', function() {
                App.trigger('messageCenter:toggleView');
            });
            $('.messageCenterButton, .menu-mail-item').on('close.custom', function() {
                self.closeMessageCenter();
            });
            $('.messageCenterButton, .menu-mail-item').on('open.custom', function() {
                self.showMessageCenter();
            });

            $('#messageCenterPopupRemove .messageCenterPopupRemoveSubmit').on('click', function() {
                App.trigger('messageCenter:messages:delete:confirmed');

                $(this).closest('.modal').modal('hide');
            });

            $('#messageCenterPopupRemove').on('hidden.bs.modal', function () {
                App.trigger('messageCenter:messages:delete:canceled');
            });

            $('body').on('keydown', function(e) {
                if (self.isMessageCenterOpen() && e.keyCode === 27) { // Esc
                    self.closeMessageCenter();
                }
            });

            $(window).on('orientationchange',function() {
                self.iScrollRefresh();
            });

            // close msg container when open left menu
            $('.sb-toggle-left').on('touchend click', function() {
                if($(self.el).hasClass('showed')) {
                    self.ui.messageCenterModalCloseButton.trigger('click');
                }
            });

            $('#messageCenterPopupRemove').appendTo($('body'));
            $('#messageCenterPopupRemove').css('right', 0).css('bottom', 0);

            this.iScrollInit();
        },
        openMessageCenter: function (options) {
            var withScrolling = options && typeof options.withScrolling !== 'undefined' ? options.withScrolling : true;

            if(withScrolling && $(window).scrollTop() > 0) {
                var $msgIcon = $('.messageCenterButton, .menu-mail-item').filter(':visible').first();
                $msgIcon.scrollToFocused();
            }

            this.showMessageCenter();
        },
        posMsgContainer: function() {
            var self = this,
                topOffset;

            if($(window).width() > 767) {
                self.$el.css('right', $(window).width() - $('.messageCenterButton').offset().left - 77);
                topOffset = $('.messageCenterButton').offset().top + $('.messageCenterButton').height();
            } else {
                self.$el.css('right', 0);
                topOffset = $('.messageCenterButtonMobile').offset().top + $('.messageCenterButtonMobile').height();
            }

            self.$el.css('top', topOffset);
        },
        onMessageCenterInited: function() {
            this.checkButtons();
            this.recalculateCountMessages();
            this.viewLessMessages();
        },
        checkButtons: function() {
            if(!this.countAllMessages) {
                this.showEmptyView();
            } else {
                this.hideEmptyView();
            }
        },
        showEmptyView: function() {
            this.ui.emptyMessageCenterMessage.show();
            this.ui.viewAllButton.hide();
            this.ui.viewLessButton.hide();
            $('.youHaveNewMessages').hide();
        },
        hideEmptyView: function() {
            this.ui.emptyMessageCenterMessage.hide();
        },
        viewAllMessages: function() {
            this.hideViewAll();

            this.iScrollRefresh();
        },
        viewLessMessages: function() {
            if(this.countAllMessages > this.maxCountMessages) {
                this.ui.viewLessButton.hide();
                this.ui.viewAllButton.show();
            }
            $(this.ui.messageCenterModalRows.selector).filter(':gt(' + (this.maxCountMessages-1) + ')').hide();
            $(this.ui.messageCenterModalRows.selector).filter(':lt(' + (this.maxCountMessages) + ')').show();

            this.iScrollRefresh();
            this.viewAll = false;
        },
        toggleMessageCenterView: function() {
            if (this.isMessageCenterOpen()) {
                this.closeMessageCenter();
            } else {
                this.showMessageCenter();
            }
        },
        isMessageCenterOpen: function() {
            return $('.messageCenterButton').hasClass('opened');
        },
        closeMessageCenter: function() {
            this.$el.removeClass('showed');
            $('.messageCenterButton').removeClass('opened');
            ga('send', {
                hitType: 'event',
                eventCategory: 'Message Center',
                eventAction: 'click on "Message Center" Header trigger',
                eventLabel: 'Message Center: Close'
            });
        },
        showMessageCenter: function() {
            // prepare msg center messages
            if(! this.messagesInitialized) {
                this.messagesInitialized = true;
                this.trigger('messageCenter:messages:initialize');
            }

            this.$el.addClass('showed');
            $('.messageCenterButton').addClass('opened');

            ga('send', {
                hitType: 'event',
                eventCategory: 'Message Center',
                eventAction: 'click on "Message Center" Header trigger',
                eventLabel: 'Message Center: Open'
            });
        },
        setCountNewMessages: function(count) {
            if(count > 0) {
                $('.messageCenterButtonNumber').text(count).show();
                $('.youHaveNewMessages').show();
                $('.youHaveNewMessages .count').text(count);
                $('.youHaventNewMessages').hide();
                $('.messageCenterButton, .messageCenterButtonMobile').addClass('haveUnreadMessages').attr('role', 'button');
            } else {
                $('.messageCenterButtonNumber').hide();
                $('.youHaveNewMessages').hide();
                $('.youHaventNewMessages').show();
                $('.messageCenterButton, .messageCenterButtonMobile').removeClass('haveUnreadMessages').attr('role', 'button');
            }
        },
        onSuccessfullyDeleted: function() {
            this.countAllMessages--;

            this.checkButtons();
            this.recalculateCountMessages();
            if(this.viewAll && this.countAllMessages > this.maxCountMessages) {
                this.viewAllMessages();
            } else {
                this.viewLessMessages();
            }
        },
        recalculateCountMessages: function() {
            var countMessages = this.countAllMessages;

            if(countMessages <= this.maxCountMessages) {
                this.ui.viewLessButton.hide();
                this.ui.viewAllButton.hide();
            }

            this.calculateMessagesHeight(countMessages > this.maxCountMessages || !countMessages ? false : true);
        },
        hideViewAll: function() {
            $(this.ui.messageCenterModalRows.selector).show();

            var countMessages = this.countAllMessages;

            if(countMessages <= this.maxCountMessages) {
                this.ui.viewLessButton.hide();
            } else {
                this.ui.viewLessButton.show();
            }
            this.ui.viewAllButton.hide().blur();

            this.viewAll = true;
            this.iScrollRefresh();
        },
        iScrollInit: function () {
            this.iScroll = new IScroll('#' + this.ui.iScrollContainer.attr('id'), {
                scrollbars: true,
                mouseWheel: true,
                interactiveScrollbars: true,
                fadeScrollbars: false,
                bounce: false,
                //click: true
            });
        },
        iScrollRefresh: function() {
            this.calculateMessagesHeight();
            if(this.iScroll) {
                this.iScroll.refresh();
            }
        },
        calculateMessagesHeight: function() {
            var height = 0;

            if(this.countAllMessages <= this.maxCountMessages) {
                height = this.ui.messagesListContainer.innerHeight();
                var firstChild = this.ui.messagesListContainer.find('.messageCenterModalRow .messageCenterModalTitle').filter(':visible').first(),
                    maxHeight = this.maxCountMessages * (firstChild.innerHeight() + 31);
                height = height > maxHeight ? maxHeight : height;
            }
            else {
                this.ui.messagesListContainer.find('.messageCenterModalRow').filter(':visible').filter(':lt(' + this.maxCountMessages + ')').each(function (k, val) {
                    height += ($(val).find('.messageCenterModalTitle').innerHeight() + 31);
                });
            }
            var offset = this.ui.msgControlButtonsContainer.height();

            this.ui.iScrollContainer.height(height + offset);
        }
    });


});
